import React from "react";
import { InputGroup, Input, InputRightElement } from "@chakra-ui/react";
import { debounce } from "lodash";
import { Search } from "lucide-react";
import { useCallback, useState } from "react";

export const SearchTextfield = ({
  placeholder,
  value,
  onChange,
}: {
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
}) => {
  const [searchInput, setSearchInput] = useState(value ?? "");

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      onChange(value);
    }, 300),
    []
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchInput(value);
    debouncedSearch(value);
  };
  return (
    <InputGroup bg="boxBg" borderRadius="xl" py={2} maxW="300px">
      <Input
        placeholder={placeholder ?? "Search"}
        variant="unstyled"
        pl={5}
        value={searchInput}
        onChange={handleSearchChange}
      />
      <InputRightElement pointerEvents="none">
        <Search size={16} color="#878787" />
      </InputRightElement>
    </InputGroup>
  );
};
